import React from 'react';
import Button from '../General/Button';
import Link from 'next/link';
import helpers from '../../utils/helpers';

function AffordableFinancing() {
    return (
        <div id='affordable-financing' className='--align py-10 lg:py-[95px]' style={{ background : 'rgba(253, 236, 229, 0.4)' }}>
            <div className='md:flex md:flex-row-reverse md:justify-between md:items-center'>
                <div className='md:w-[50%] lg:w-[39%]'>
                    <img className='w-full md:w-full' src="/Home/AffordableFinancing.svg" alt="QuickDelivery" loading='lazy'/>
                </div>

                <div className='mt-[20px] md:w-[40%] lg:w-[50%]'>
                    <h5 className='text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]'>Affordable Financing Options</h5>

                    <p className='text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]'>
                        APIdrug's global marketplace offers some of the cheapest financing options in the industry, 
                        enabling you to benefit from economies of scale. Our flexible payment terms help you manage 
                        cash flow and invest in business growth. Our fast and hassle-free financing process has helped 
                        thousands of customers worldwide to increase profitability. Choose APIdrug to access affordable 
                        financing options and stay ahead of the competition.
                    </p>

                    <div className='flex justify-between items-center mt-[34px] lg:justify-start'>
                        <p onClick={() => helpers.scrollTo('enquiry-section', 140)} className='w-[48%] lg:w-[193px] lg:mr-[20px]'>
                            <Button styles = "bg-white text-theme-orange border border-theme-orange w-full h-[42px] lg:h-[54px] font-[400] lg:text-[18px]" >
                                Open Bulk Deals
                            </Button>
                        </p>
                        <Link href={'/spot-buying'} className='w-[48%] lg:w-[193px]'>
                            <Button styles = "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]">
                                Open Spot Prices
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AffordableFinancing